import Operator from './operator';
var within;
within = function (field) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    if (values && values.length == 1 && values[0] instanceof Array) {
        return {
            operator: Operator.in,
            field: field,
            values: values[0],
        };
    }
    else {
        return {
            operator: Operator.in,
            field: field,
            values: values
        };
    }
};
export default within;
